export interface IStatistics {
    ucqBoatmaster: number;
    ucqLngExpert: number;
    ucqPassengerExpert: number;
    ucqDeckhand: number;
    ucqApprentice: number;
    ucqBoatman: number;
    ucqAbleBoatman: number;
    ucqHelmsman: number;
    boatmasterAt: number;
    pleasureCraft: number;
    certificateStretches: number;
    engineersCertificate: number;
}

export interface IStatisticsResult {
    activeCertificates: IStatistics;
    issuedCertificates: IStatistics;
    suspendedCertificates: IStatistics;
    withdrawnCertificates: IStatistics;
}

export const statisticsInit: IStatistics = {
    ucqBoatmaster: 0,
    ucqHelmsman: 0,
    ucqAbleBoatman: 0,
    ucqBoatman: 0,
    ucqDeckhand: 0,
    ucqApprentice: 0,
    ucqLngExpert: 0,
    ucqPassengerExpert: 0,
    boatmasterAt: 0,
    pleasureCraft: 0,
    certificateStretches: 0,
    engineersCertificate: 0,
};
